import { store } from './store';

export const apiDomain = "https://building-api.companee.it/";
export const loginUrl = apiDomain + "api/login";
export const usersUrl = apiDomain + "api/users";
export const userInfoUrl = apiDomain + "api/userinfo";
export const rolesUrl = apiDomain + "api/roles";
export const permissionsUrl = apiDomain + "api/permissions";
export const quotationsUrl = apiDomain + "api/quotations";
export const customersUrl = apiDomain + "api/customers"

export const getHeader = function() {
    const auth = store.getters.auth;
    const headers = {
        'Accept':'application/json',
        'Authorization': 'Bearer ' + auth.token
    }

    return headers;
}
